import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { confirmNewsletter, emailAddressNewsletter, thanksNewsletter } from './newsletter-steps'

export const newsletterScenarioA: Scenario = {
  id: 'newsletter-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.NEWSLETTER,
  version: '1',
  milestones: [emailAddressNewsletter.id, confirmNewsletter.id, thanksNewsletter.id],
  steps: [emailAddressNewsletter, confirmNewsletter, thanksNewsletter],
}
